import ResetPasswordGeneric from './ResetPasswordGeneric';

export default function ResetPassword() {
    return (
        <ResetPasswordGeneric
            apiEndpoint="/area-generale/reset-password"
            titolo="Username o email"
            loginUrl="/login"
        />
    );
}
